import { useState, type FormEvent } from "react";
import { api, type AuthUser } from "../lib/api";
import logoUrl from "../assets/sibit-logo.jpg";

export function LoginPage(props: { onLogin: (u: AuthUser) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const user = await api.login(email, password);
      props.onLogin(user);
    } catch (e: any) {
      setErr(e.message.includes("401") ? "E-Mail oder Passwort falsch." : "Login fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit}>
        <img src={logoUrl} alt="Sibit Personalverrechnung" className="login-logo" />
        <p className="login-sub">Anmelden</p>

        <label className="field">
          <span>E-Mail</span>
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={busy}
          />
        </label>

        <label className="field">
          <span>Passwort</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
          />
        </label>

        {err && <div className="error">{err}</div>}

        <button type="submit" className="primary" disabled={busy}>
          {busy ? "…" : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
